import { Navigate, useLocation } from 'react-router-dom';

/**
 * Redirects requests from menu domain (siply.pro) to the /menu/:slug route.
 * This handles the case where users access siply.pro/gin-palast directly,
 * which needs to be internally routed to /menu/gin-palast.
 */
export function MenuDomainRedirect() {
  const location = useLocation();
  const path = location.pathname;

  // Check if we're on the menu domain (siply.pro)
  // First check env var, then fall back to hostname check
  const menuDomain = import.meta.env.VITE_MENU_URL;
  const hostname = window.location.hostname;
  const isMenuDomain = menuDomain
    ? window.location.origin === menuDomain
    : hostname === 'siply.pro' || hostname === 'www.siply.pro';

  // Known app routes that should NOT be treated as menu slugs
  const reservedPaths = [
    '/login',
    '/register',
    '/dashboard',
    '/distillery',
    '/brewmaster',
    '/events',
    '/venues',
    '/live-orders',
    '/analytics',
    '/spirits',
    '/trends',
    '/api-keys',
    '/webhooks',
    '/settings',
    '/monitoring',
    '/orders',
    '/menu',
    '/impressum',
    '/datenschutz',
    '/kontakt',
  ];

  // Check if current path is a reserved route
  const isReservedPath = reservedPaths.some(
    reserved => path === reserved || path.startsWith(reserved + '/')
  );

  // If on menu domain and path looks like a slug (not a reserved path)
  if (isMenuDomain && !isReservedPath && path !== '/') {
    // Extract slug from path (e.g., /gin-palast -> gin-palast)
    const slug = path.substring(1); // Remove leading slash

    // Only redirect if it looks like a valid slug (alphanumeric with dashes/underscores)
    if (/^[a-zA-Z0-9_-]+$/.test(slug)) {
      // Preserve query params (like ?table=5)
      const queryString = location.search;
      return <Navigate to={`/menu/${slug}${queryString}`} replace />;
    }
  }

  // Default: redirect to dashboard (requires auth, will redirect to login)
  return <Navigate to="/dashboard" replace />;
}

export default MenuDomainRedirect;
